import { render } from "./TrendiRecruit.vue?vue&type=template&id=6e698baa"
import script from "./TrendiRecruit.vue?vue&type=script&lang=js"
export * from "./TrendiRecruit.vue?vue&type=script&lang=js"

import "./TrendiRecruit.vue?vue&type=style&index=0&id=6e698baa&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__